import { configureStore } from "@reduxjs/toolkit";
import { userSlice } from "./slices/user/user";
import { menuSlice } from "./slices/menu/menu";

export const store = configureStore({
	// todas los reducers de los slices
	// exampleName es la forma en la cual se llamaran dentro de los componentes
	reducer: {
		user: userSlice.reducer,
		menu: menuSlice.reducer,
	},
});
